<template>
  <div class="setting-row">
    <div class="label">
      {{ label }}
    </div>
    <div class="value">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
type TProps = {
  label: string;
};
defineProps<TProps>();
</script>

<style lang="scss" scoped>
.setting-row {
  display: flex;
  align-items: baseline;

  & + & {
    margin-top: 8px;
  }

  .label {
    flex-shrink: 0;
    width: 100px;
    margin-right: 0.5em;
    color: $textcolor-light;
  }

  .value {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;

    // 表示専用の SimpleSelect が出力する要素（span / div）に省略記号を効かせる
    :deep(span),
    :deep(div) {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
